import { FavoriteLead } from "features/leads/components";

import { MobileSelectionListItem } from "common/components/MobileSelectionList";
import MobileSelectionList from "common/components/MobileSelectionList/MobileSelectionList";
import ProfileImage from "common/components/ui/ProfileImage";
import Skeleton from "common/components/ui/Skeleton";
import type { Lead } from "common/types";

import { LEADS_COLUMNS } from "../../../constants";
import LeadNotesIndicator from "../LeadNotesIndicator";

interface MobileListProps {
  leads: Lead[];
  selectedLeads: Lead[];
  setSelectedLeads: (selectedLeads: Lead[]) => void;
  isLoading: boolean;
  pageSize: number;
  totalItemCount: number;
}

export default function MobileList({
  leads,
  selectedLeads,
  setSelectedLeads,
  pageSize,
  isLoading,
  totalItemCount,
}: MobileListProps) {
  return (
    <MobileSelectionList
      title="Leads"
      data={leads || new Array(pageSize).fill(null)}
      selection={selectedLeads}
      onSelectionChange={
        isLoading
          ? undefined
          : (newSelection) => {
              if (newSelection === "all") {
                setSelectedLeads(selectedLeads === leads ? [] : leads);
              } else {
                setSelectedLeads(newSelection);
              }
            }
      }
      totalDataCount={totalItemCount}
      allItems={LEADS_COLUMNS}
      canSelectAll={false}
    >
      {(lead, listItemProps, selectedItems) => {
        if (isLoading) {
          return (
            <MobileSelectionListItem {...listItemProps}>
              <Skeleton className="rounded-full size-8" />
              <Skeleton className="w-28 h-4" />
            </MobileSelectionListItem>
          );
        }
        if (lead) {
          const { id, picture_url, notes, favorite, full_name, occupation } =
            lead;

          return (
            <MobileSelectionListItem
              {...listItemProps}
              relativeTo={`/leads/${id}`}
            >
              <ProfileImage src={picture_url} size="sm" />
              <div className="flex flex-col flex-1 overflow-hidden">
                <div className="flex items-center gap-x-1">
                  <span className="text-start text-xs-bold text-nowrap truncate flex-1">
                    {full_name}
                  </span>
                  <div className="flex gap-x-1 items-center">
                    <LeadNotesIndicator noteCount={notes.length} />
                    <FavoriteLead leadId={id} isFavorite={favorite} />
                  </div>
                </div>
                {selectedItems.includes("occupation") && (
                  <span className="text-left text-button-xxs text-black-500 truncate">
                    {occupation}
                  </span>
                )}
              </div>
            </MobileSelectionListItem>
          );
        }
      }}
    </MobileSelectionList>
  );
}
